export const TABLE_HEADERS = ['Device Type', 'No. of Accounts'];

export const DEVICES_ROUTE = '/app/manage/devices';
